import { Injectable } from '@angular/core';
import { CanDeactivate, CanActivate } from '@angular/router';
import { CreateShipmentComponent } from './create-shipment.component';
import { ConfirmDialogRequest } from '../../shared/confirm-dialog/confirm-dialog.component';
import { switchMap, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { ShipmentFormService } from './../service/shipment-form-service';

@Injectable()
export class CreateShipmentFormGuard implements CanActivate, CanDeactivate<CreateShipmentComponent> {

    constructor(
        private service: ShipmentFormService
    ) { }

    public async canDeactivate(component: CreateShipmentComponent) {
        const { formValue, barcodes } = this.service.getLocalStorage();
        if (!component.showNotSavedAlert || this.oneFieldFilled(component.shipmentFormGroup, barcodes)) {
            this.service.deleteLocalStorage();
            return true;
        }
        let result = await this.confirmation().toPromise();
        if (result) {
            this.service.deleteLocalStorage();
        }
        return result;
    }

    public async canActivate() {
        const { formValue, barcodes } = this.service.getLocalStorage();
        if (formValue || barcodes) {
            let result = await this.confirmationOnLoad().toPromise();
            if (result) {
                this.service.deleteLocalStorage();
            }
        }
        return true;
    }

    private confirmation(): Observable<boolean> {

        let dialogRequest: ConfirmDialogRequest = {
            message: 'Are you sure you want to cancel this shipment ? <br>This action cannot be undone.',
            yesButtonText: 'No, keep this shipment',
            noButtonText: 'Leave'
        };
        return this.service.showConfirmDialog(dialogRequest).pipe(
            switchMap(dialog => dialog.onHide()),
            map(dialogResult => dialogResult.isCancelled || false));

    }

    private confirmationOnLoad(): Observable<boolean> {

        let dialogRequest: ConfirmDialogRequest = {
            message: `Do you want to continue from where you left ?<br>
            Click on Yes to continue or No to start a new Shipment entry.`,
            yesButtonText: 'Yes',
            noButtonText: 'No'
        };
        return this.service.showConfirmDialog(dialogRequest).pipe(
            switchMap(dialog => dialog.onHide()),
            map(dialogResult => dialogResult.isCancelled || false));

    }

    private oneFieldFilled(formGroup: FormGroup, barcodes: string): boolean {
        if (barcodes) { return false; }
        let controls = formGroup.controls;
        if (controls) {
            let filledControls = Object.keys(controls).filter(key => controls[key].value !== '');
            if (filledControls && filledControls.length === 3) {
                return true;
            }
            return false;
        }
        return true;

    }
}